import { useEffect, useState } from "react";
import { api } from "../api";
import type { UserResponse } from "@shared/types";

interface Props { onClose: () => void; }

export function UsersPanel({ onClose }: Props) {
  const [users, setUsers] = useState<UserResponse[]>([]);
  const [newUsername, setNewUsername] = useState("");
  const [newName, setNewName] = useState("");
  const [newAdmin, setNewAdmin] = useState(false);

  async function refresh() {
    const res = await api.listUsers();
    if (res) setUsers(res.users);
  }

  useEffect(() => { refresh(); }, []);

  async function createUser() {
    if (!newUsername.trim()) return alert("Informe o username");
    try {
      const r = await api.createUser(newUsername.trim(), newName.trim() || newUsername.trim(), newAdmin);
      if (r) alert(`Usuário criado.\nSenha temporária: ${r.temp_password}\n(anote — não será mostrada novamente)`);
      setNewUsername("");
      setNewName("");
      setNewAdmin(false);
      refresh();
    } catch (e: any) { alert("Erro: " + e.message); }
  }

  async function resetPw(id: number) {
    if (!confirm("Gerar nova senha temporária?")) return;
    const r = await api.patchUser(id, { reset_password: true });
    if (r?.temp_password) alert(`Nova senha temporária: ${r.temp_password}`);
  }

  async function toggleActive(id: number, makeActive: boolean) {
    await api.patchUser(id, { is_active: makeActive });
    refresh();
  }

  return (
    <div className="overlay open" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal" style={{ maxWidth: 640 }}>
        <h2>Usuários</h2>
        <div style={{ display: "flex", gap: 8, marginBottom: 14, alignItems: "end" }}>
          <div className="fr" style={{ flex: 1, margin: 0 }}>
            <label>Novo usuário</label>
            <input placeholder="username" value={newUsername} onChange={e => setNewUsername(e.target.value)} />
          </div>
          <div className="fr" style={{ flex: 1, margin: 0 }}>
            <label>Nome</label>
            <input placeholder="nome de exibição" value={newName} onChange={e => setNewName(e.target.value)} />
          </div>
          <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 6 }}>
            <input type="checkbox" checked={newAdmin} onChange={e => setNewAdmin(e.target.checked)} />
            Admin
          </label>
          <button className="btn-save" onClick={createUser}>Criar</button>
        </div>
        <table style={{ width: "100%", fontSize: 13 }}>
          <thead><tr><th style={{ textAlign: "left" }}>Usuário</th><th>Nome</th><th>Papel</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td>{u.username}</td>
                <td>{u.display_name}</td>
                <td>{u.is_admin ? "Admin" : "—"}</td>
                <td>{u.is_active ? "Ativo" : "Desativado"}</td>
                <td>
                  <button className="btn-sm" onClick={() => resetPw(u.id)}>Resetar senha</button>
                  <button className="btn-sm" onClick={() => toggleActive(u.id, !u.is_active)}>{u.is_active ? "Desativar" : "Reativar"}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mfoot"><button className="btn-cancel" onClick={onClose}>Fechar</button></div>
      </div>
    </div>
  );
}
